import { RootState } from 'app/store';

export const selectUser = (state: RootState) => state.login.user;

export const selectUserLoading = (state: RootState) => state.login.loading;

export const selectLoginError = (state: RootState) => state.login.loginError;

export const selectTfaVerifyError = (state: RootState) => state.login.tfaError;

export const selectForgottenPasswordError = (state: RootState) =>
  state.login.forgottenPasswordError;

  export const selectForgottenPasswordSuccess = (state: RootState) =>
  state.login.forgottenPasswordSuccess;
